/* External dependencies */
import React, { useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';

/* Local dependencies */
import { store, AppDispatch } from './store';
import { restoreSessionAction } from '../components/webApp/authredux/actions';

const RestoreSession: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const isAuthenticated = localStorage.getItem('isAuthenticated');
    const userRaw = localStorage.getItem('user');

    if (isAuthenticated !== 'true') return;
    if (!userRaw || userRaw === 'undefined') return;

    try {
      const user = JSON.parse(userRaw);
      dispatch(restoreSessionAction(user));
    } catch (error) {
      console.error('Failed to restore session:', error);
      localStorage.removeItem('user');
      localStorage.removeItem('isAuthenticated');
    }
  }, [dispatch]);

  return <>{children}</>;
};

const WrapWithProvider = ({ element }: { element: React.ReactNode }) => {
  return (
    <Provider store={store}>
      <RestoreSession>{element}</RestoreSession>
    </Provider>
  );
};

export default WrapWithProvider;
